export const TIPO_INSPECCION = {
  FISICO: 1,
  DOCUMENTAL: 2,
  AUDITORIA_POSTERIORI: 3,
  SIN_AFORO: 4,
};

export const TIPO_INSPECCION_NOMBRES = {
  FISICO: 'Examen Físico',
  DOCUMENTAL: 'Examen Documental',
  AUDITORIA_POSTERIORI: 'Auditoría a Posteriori',
  SIN_AFORO: 'Sin aforo',
};

export default TIPO_INSPECCION;
